import { AppPermissions } from '@shared/types'

import { useSessionContext } from './useSessionContext'

const BROKER_APP_PERMISSIONS = [
  AppPermissions.SECTION_SALES,
  AppPermissions.SALES_PANEL,
  AppPermissions.SECTION_ORDERS,
  AppPermissions.SECTION_CUSTOMERS,
  AppPermissions.SECTION_REPORTS,
  AppPermissions.PRODUCT_MEDICAL_TRAVEL,
  AppPermissions.PRODUCT_ACCIDENTS,
  AppPermissions.PRODUCT_PROPERTY,
  AppPermissions.PRODUCT_CASCO,
  AppPermissions.PRODUCT_CMR,
  AppPermissions.CONTRACTS_REGISTRY
] as const

export const usePermissionRestriction = () => {
  const { isAdmin, profile, broker } = useSessionContext()

  const foundAgentApplicationPermissions = profile?.teams?.reduce(
    (prev, next) => [
      ...prev,
      ...(next?.permissions?.map(({ permission }) => permission) || [])
    ],
    [] as AppPermissions[]
  )

  const foundBrokerApplicationPermissions = BROKER_APP_PERMISSIONS?.filter(
    (permission) => foundAgentApplicationPermissions?.includes(permission)
  )

  const foundApplicationPermissions = broker
    ? foundBrokerApplicationPermissions
    : foundAgentApplicationPermissions

  const hasBrokerAdminPermission = (permissions?: AppPermissions[]) =>
    !!broker?.user?.is_broker_admin &&
    BROKER_APP_PERMISSIONS.some((permission) =>
      permissions?.includes(permission)
    )

  const hasPermission = (permissions?: AppPermissions[]) =>
    isAdmin ||
    hasBrokerAdminPermission(permissions) ||
    !!foundApplicationPermissions?.some((permission) =>
      permissions?.includes(permission)
    )

  return { hasPermission }
}
